import { render, staticRenderFns } from "./JiangsuDetail.vue?vue&type=template&id=8a96ce2a&scoped=true"
import script from "./JiangsuDetail.vue?vue&type=script&lang=js"
export * from "./JiangsuDetail.vue?vue&type=script&lang=js"
import style0 from "./JiangsuDetail.vue?vue&type=style&index=0&id=8a96ce2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a96ce2a",
  null
  
)

export default component.exports